import { render, staticRenderFns } from "./networkclass.vue?vue&type=template&id=be078a12&scoped=true&"
import script from "./networkclass.vue?vue&type=script&lang=js&"
export * from "./networkclass.vue?vue&type=script&lang=js&"
import style0 from "./networkclass.vue?vue&type=style&index=0&id=be078a12&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be078a12",
  null
  
)

export default component.exports